"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
const core_1 = require("@angular/core");
const index_1 = require("../interfaces/index");
let ExpandablePanelComponent = class ExpandablePanelComponent {
    constructor(_expandablePanelCollection) {
        this._expandablePanelCollection = _expandablePanelCollection;
    }
    get id() {
        return this.panelId;
    }
    get isExpanded() {
        return this._isExpanded;
    }
    onShrink() {
        let p = this._expandablePanelCollection.get(this.id);
        if (p) {
            p.shrink();
        }
    }
    ngOnInit() {
        console.log("ExpandablePanelComponent.ngOnInit", this.panelId);
        this._isExpanded = this.initiallyExpanded || false;
        this._expandablePanelCollection.add(this);
    }
    ngOnDestroy() {
        this._expandablePanelCollection.remove(this);
    }
    expand() {
        this._isExpanded = true;
    }
    shrink() {
        this._isExpanded = false;
    }
    toggle() {
        this._isExpanded = !this._isExpanded;
    }
};
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], ExpandablePanelComponent.prototype, "panelId", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], ExpandablePanelComponent.prototype, "initiallyExpanded", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], ExpandablePanelComponent.prototype, "pinnable", void 0);
ExpandablePanelComponent = __decorate([
    core_1.Component({
        selector: 'expandable-panel',
        templateUrl: './@inax/commonUi/src/expandablePanel/expandablePanelComponent/expandablePanel.component.html'
    }),
    __param(0, core_1.Inject(index_1.IEXPANDABLEPANELCOLLECTIONSERVICE_TOKEN)),
    __metadata("design:paramtypes", [Object])
], ExpandablePanelComponent);
exports.ExpandablePanelComponent = ExpandablePanelComponent;
